/**
 * What of a kept scan the fleet may show.
 *
 * - **`external` only.** `managed` rows are already on the fleet from their
 *   runs, and `adopted` ones from their adoption record; repeating them would
 *   put one instance on the screen twice.
 * - **Not gone.** A disappeared row is history the account screen keeps on
 *   purpose (a clean-up made visible). At fleet level it is noise: the question
 *   here is what is out there now.
 * - **Not hidden.** Applied on the way out, like the per-account read, so a
 *   hide made since the last scan takes effect without paying for another.
 */
export const unmanagedOf = (inventory, hidden) => inventory.instances.filter((entry) => entry.origin === 'external' &&
    entry.goneSince === undefined &&
    !hidden.has(entry.deploymentId));
/**
 * The rows the fleet table renders.
 *
 * `managed` is every instance the fleet already lists, so one AWS account
 * registered under two customers cannot show an instance once as ours and
 * again as nobody's: `origin` is decided per customer, and only the fleet sees
 * both.
 *
 * Storage-only leftovers are left out unless asked for. There are a great many
 * — every `destroy --skip-s3-buckets` leaves a set — and they would bury the
 * running clusters that are the reason anyone opened this. Mauricio,
 * 2026-10-22: "in the same list with a filter (hidden by default)".
 */
export const foundInstances = (found, managed, includeResidue) => {
    const known = new Set(managed.map((m) => JSON.stringify([m.accountKey, m.deploymentId])));
    const rows = [];
    for (const account of found.accounts) {
        if (account.scannedAt === undefined)
            continue;
        for (const entry of account.instances) {
            if (!includeResidue && entry.state === 'residue')
                continue;
            if (known.has(JSON.stringify([account.accountKey, entry.deploymentId])))
                continue;
            rows.push({
                ...entry,
                tenantId: account.tenantId,
                tenantName: account.tenantName,
                tenantKind: account.tenantKind,
                accountKey: account.accountKey,
                accountLabel: account.label,
                scannedAt: account.scannedAt,
            });
        }
    }
    return rows;
};
/** The oldest kept scan among accounts that have one, for "as of" wording. */
export const oldestScan = (found) => found.accounts
    .map((a) => a.scannedAt)
    .filter((at) => at !== undefined)
    .sort()[0];
//# sourceMappingURL=fleet-found.js.map